import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { Parameters } from '../../models';
import { BaseQuery } from '../common/base-query.class';
export var SingleItemQuery =
/*#__PURE__*/
function (_BaseQuery) {
  _inherits(SingleItemQuery, _BaseQuery);

  function SingleItemQuery(config, queryService, codename) {
    var _this;

    _classCallCheck(this, SingleItemQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleItemQuery).call(this, config, queryService));
    _this.config = config;
    _this.queryService = queryService;
    _this.codename = codename;
    _this._queryConfig = {};

    if (!codename) {
      throw Error("'codename' has to be configured for 'SingleItemQuery' query");
    }

    return _this;
  }
  /**
   * Indicates depth of query that affects loading of nested linked items.
   * @param depth Depth of the query (> 0)
   */


  _createClass(SingleItemQuery, [{
    key: "depthParameter",
    value: function depthParameter(depth) {
      this.parameters.push(new Parameters.DepthParameter(depth));
      return this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */

  }, {
    key: "queryConfig",
    value: function queryConfig(_queryConfig) {
      this._queryConfig = _queryConfig;
      return this;
    }
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */

  }, {
    key: "languageParameter",
    value: function languageParameter(languageCodename) {
      this.parameters.push(new Parameters.LanguageParameter(languageCodename));
      return this;
    }
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */

  }, {
    key: "elementsParameter",
    value: function elementsParameter(elementCodenames) {
      this.parameters.push(new Parameters.ElementsParameter(elementCodenames));
      return this;
    }
  }, {
    key: "toPromise",
    value: function toPromise() {
      var _a;

      return this.queryService.getSingleItemAsync(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var action = '/items/' + this.codename; // add default language is necessry

      this.processDefaultLanguageParameter();
      return _get(_getPrototypeOf(SingleItemQuery.prototype), "resolveUrlInternal", this).call(this, action);
    }
  }, {
    key: "map",
    value: function map(json) {
      return this.queryService.mappingService.viewContentItemResponse(json);
    }
  }]);

  return SingleItemQuery;
}(BaseQuery);